import store from '@/store'
import JSzip from 'jszip'
import QRcode from 'qrcodejs2'
import { saveAs } from 'file-saver'
import { ElMessageBox, ElMessage } from 'element-plus'
import { computed, toRaw } from "vue";
import { resetRouter } from "@/utils/routeUtil.js";

// 深拷贝
export function deepClone(obj, hash = new WeakMap()) {
    // 处理原始值和 null（放在最前面）
    if (obj === null || typeof obj !== 'object') return obj;

    // 处理循环引用
    if (hash.has(obj)) return hash.get(obj);

    // 处理特殊对象类型（优先于 Vue 响应式判断）
    if (obj instanceof Date) return new Date(obj);
    if (obj instanceof RegExp) return new RegExp(obj);
    // 添加其他内置类型处理（如 Map/Set 等）

    // 处理 Vue 响应式对象（获取原始值）
    const rawObj = toRaw(obj); // 关键：解除 Proxy 包装
    if (rawObj !== obj) { // 说明原始对象是响应式 Proxy
        return deepClone(rawObj, hash); // 递归克隆原始值
    }

    // 创建克隆对象
    const clone = Array.isArray(obj) ? [] : {};
    hash.set(obj, clone);

    // 过滤 Vue 内部属性（以 __v_ 或 _ 开头的属性）
    Reflect.ownKeys(obj).forEach(key => {
        if (typeof key === 'string' && (key.startsWith('__v_') || key.startsWith('_'))) {
            return; // 跳过 Vue 内部属性
        }
        clone[key] = deepClone(obj[key], hash);
    });

    return clone;
}

// 清除 登录状态及相关数据
export function removeLoginStatus() {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('expire')
    sessionStorage.removeItem('visitedViews')
}


// vuex持久化
export function vuexPersisted() {
    //console.log('vuex持久化执行，验证是否过期');

    let expire = localStorage.getItem('expire')   // 过期时间
    let currentTime = Date.now()

    //console.log('过期时间：', expire);
    //console.log('当前时间', currentTime);

    if (expire - currentTime <= 0 && expire != '' && expire != null) {
        // 时间已经过期了
        //console.log('时间已经过期了');
        // 无效的会话，或者会话已过期，请重新登录。
        ElMessage.error("无效的会话，或者会话已过期，请重新登录。");
        removeLoginStatus()
        // 路由相关信息页一并清除
        resetRouter()
        return
    }

    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let token = localStorage.getItem('token')

    store.commit('setUserInfo', userInfo)
    store.commit('setToken', token)
}


// 时间格式化
export function transformTime(timestamp, format_str) {
    format_str = format_str || "yyyy-MM-dd hh:mm:ss"
    let time = new Date(timestamp);
    // 判断是否为无效时间
    if (isNaN(time.getTime())) {
        time = new Date();
    }

    let yyyy = time.getFullYear(); //getFullYear方法以四位数字返回年份
    let MM = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
    let dd = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
    let hh = time.getHours(); // getHours方法返回 Date 对象的小时 (0 ~ 23)
    let mm = time.getMinutes(); // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
    let ss = time.getSeconds(); // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)

    if (MM < 10) {
        MM = '0' + MM
    }
    if (dd < 10) {
        dd = '0' + dd
    }
    if (hh < 10) {
        hh = '0' + hh
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    if (ss < 10) {
        ss = '0' + ss
    }
    return format_str.replace('yyyy', yyyy).replace('MM', MM).replace('dd', dd).replace('hh', hh).replace("mm", mm).replace('ss', ss);
}

// 获取当前星期
export function getWeek() {
    const date = new Date();
    const dayIndex = date.getDay(); // 获取0-6的数字（0=周日，1=周一...6=周六）
    const weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    const currentWeekday = weekdays[dayIndex];
    return currentWeekday
}

// 封装MessageBox，方便使用
export function showMessageBox(title, tips, data, res, rej) {
    ElMessageBox.confirm(
        tips,
        title,
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            if (typeof res === 'function') {
                res(data)
            }
        })
        .catch(() => {
            if (typeof rej === 'function') {
                rej()
            }
        })
}

// 防抖闭包
export function debounce() {
    let timer = null
    return function (fn, data, interval = 300) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn(data)
        }, interval)
    }
}

// 节流闭包
export function throttle() {
    let flag = false
    return function (fn, data, interval = 2000) {
        if (flag) return
        flag = true
        fn(data)
        setTimeout(() => {
            flag = false
        }, interval)
    }
}

// 从图片的flie文件中转换得到base64的src地址
export function getImageSrcFromFile(file) {
    return new Promise((resolve, reject) => {
        try {
            let reader = new FileReader()
            reader.onload = (e) => {
                let src = e.target.result
                resolve(src)
            }
            reader.readAsDataURL(file)
        } catch (error) {
            reject(error)
        }
    })
}

// 判断当前图片是横图还是竖图
export function checkImageOrientation(item) {
    /* return new Promise((resolve, reject) => {

        console.log(url);

        if (!url) resolve(null)
        if (url.indexOf('://') == -1) {
            // 当前链接需要加上域名前缀
            url = store.state.layout.baseImgUrl + url
        }
        const img = new Image();
        img.src = url;
        img.onload = function (event) {
            const imgElement = event.target;
            const originalWidth = imgElement.naturalWidth;
            const originalHeight = imgElement.naturalHeight;
            const ratio = originalWidth / originalHeight
            console.log('返回数据', ratio);

            if (ratio >= 1) {
                // 比例大于1的为横图
                resolve('horizontal')
            } else {
                // 比例小于1的为竖图
                resolve('vertical')
            }
        }
        img.onerror = function (event) {
            resolve(null)
        }
    }) */

    const width = item.width
    const height = item.height

    const ratio = width / height

    if (ratio >= 1) {
        // 比例大于1的为横图
        return 'horizontal'
    } else {
        // 比例小于1的为竖图
        return 'vertical'
    }
}


// 获取字典里对应的label
export function getDictLabel(value, dictList) {
    let label
    for (let index = 0; index < dictList.length; index++) {
        const item = dictList[index];
        if (value == item.value) {
            label = item.label
            break
        }
    }
    return label
}

// 获取图片的宽高尺寸
export function getImgaeDimensions(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = function (event) {
            const imgElement = event.target;
            let imgaeDimensions = {
                width: imgElement.naturalWidth,
                height: imgElement.naturalHeight
            }
            resolve(imgaeDimensions)
        }
        img.onerror = function (event) {
            reject(null)
        }
    })

}

